module.exports = __webpack_public_path__ + "static/EGR_FlashPage_2-e1eb1dca179ede520705c40203434b17.jpg";